import { useState, useEffect, useMemo } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import Form12 from './Form12';
import Form3 from './Form3';
import Form4 from './Form4';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { validMail, validEmpty, validOrderNr, validPhone, hasGeneticAnalyse, validVat } from '../../utilities/valid';
import NextArrow from '../../components/NextArrow';
import AlertWindow from '../../components/AlertWindow';
import { loadLocality, loadPrescribers, loadPurchaseOrder, logNavInfo } from '../../utilities/httpRequest';
import FormLine from '../../components/FormLine';
import { loadAnimalSex, loadSterilisationStatus, loadSpecies, loadAccount, getAnalyses, loadMatrix,logInfo } from '../../utilities/httpRequest';
import { loadCountries } from '../../utilities/httpRequest';
import TextButton from '../../components/TextButton';
import parseAddress from '../../utilities/parseAddress';
import { computeCost, atLeastOneAnalyse, fillAnalyses, fillBilans, fillCommentsAnalyses, fillCommentsBilans } from '../../utilities/utils';
import { Pet, PetOwner, Address } from '../../utilities/dataUtils';

export default function FormNewAnalisys() {

    //récupération des paramètres initiaux (import depuis formulaire d'estimation)
    const location = useLocation();
    const { initialAnalyses, initialBilans, initialSpecie } = location.state || {};
    const initialData = useMemo(() => ({
        analyses: initialAnalyses,
        bilans: initialBilans,
        specie: initialSpecie
    }), [initialAnalyses, initialBilans, initialSpecie]);

    const navigate = useNavigate();

    const [alertWindowText, setAlertWindowText] = useState("");
    const [displayAlertWindow, setDisplayAlertWindow] = useState(false);

    const [purchaseOrderId, setPurchaseOrderId] = useState(0);

    const [tab, setTab] = useState(1);

    const dataTab = [{
        id: 1,
        label: "Propriétaire & Animal"
    }, {
        id: 2,
        label: "Analyses"
    }, {
        id: 3,
        label: "Validation"
    }]

    const [validationLabel, setValidationLabel] = useState({
        firstname: "",
        name: "",
        email: "",
        country: "",
        phone: "",
        language: "",
        street: "",
        street_nb: "",
        box: "",
        locality: "",
        postal_code: "",
        vat: "",
        companyName: "",
        orderNb: "",
        petName: "",
        specie: "",
        breed: "",
        birthDate: "",
        chip: "",
        sexe: "",
        sterilisation: "",
        anamnesis: "",
        result_copy_mail: "",
        result_copy_name: ""
    });

    const [data, setData] = useState({
        petOwner: new PetOwner(),
        pet: new Pet(null, initialData.specie?.id, null, null, null, null, null, null),
        billingPrescriber: false,
        orderNb: "",
        anamnesis: "",
        fuga_guid: null,
        result_copy_mail: "",
        result_copy_name: ""
    });

    //Hook utilisé pour gérer le fait que le mail du propriétaire est semi-obligatoire
    const [noMail, setNoMail] = useState(false);
    
    const [bilans, setBilans] = useState(initialData.bilans || []);
    const [analyses, setAnalyses] = useState(initialData.analyses || []);

    //Import depuis "Simulation" (devis)

    useEffect(() => {

        async function getData(specieId) {
            try {
                // ré-initialisation au cas ou la requete échoue
                setAnalyses([])
                setBilans([])
                // Chargement des données en parallèle
                const { analysesData, bilansData } = await getAnalyses(specieId, navigate)
                // Mise à jour des états (vérification si des états initiaux existent)
                setAnalyses(analysesData);
                setBilans(bilansData);
            } catch (e) {
                console.error(e.message);
            }
        }
        //on ne charge pas les données si l'espèce est identique à l'espèce d'import pour eviter d'écraser les données d'import
        //on ne charge rien si l'espèce n'est pas définie
        if (data.pet.specie_id) {
            //on ne charge pas si on a importé des données
            if (data.pet.specie_id === initialData?.specie?.id) {

            } else {
                getData(data.pet.specie_id);
                initialData.specie && delete initialData.specie;
                //si on a chargé des données on supprime les données d'import pour éviter de ne pas recharger si on revient sur la même espèce
            }
        }
    }, [data.pet.specie_id, initialData.specie, navigate])

    const [matrix, setMatrix] = useState([]);
    useEffect(() => { loadMatrix(setMatrix, navigate) }, [navigate, setMatrix]);
    const [cost, setCost] = useState(0);
    useEffect(() => setCost(computeCost(analyses, bilans)), [analyses, bilans]);
    //Chargement des données
    const [account, setAccount] = useState({
        superuser: false
    });
    const [prescribers, setPrescribers] = useState([]);
    const [activePrescriber, setActivePrescriber] = useState(null);
    const [countries, setCountries] = useState([]);
    const [species, setSpecies] = useState([]);
    const [sterilisationStatus, setSterilisationStatus] = useState([]);
    const [animalSex, setAnimalSex] = useState([]);

    useEffect(() => { loadAccount(setAccount, navigate) }, [navigate])

    useEffect(() => {
        if (account.superuser) loadPrescribers(setPrescribers, navigate);
    }, [account.superuser, navigate])


    useEffect(() => { loadCountries(setCountries, navigate) }, [navigate]);

    useEffect(() => {loadSpecies(setSpecies, navigate)}, [navigate]);

    useEffect(() => { loadSterilisationStatus(setSterilisationStatus, navigate) }, [navigate]);

    useEffect(() => { loadAnimalSex(setAnimalSex, navigate) }, [navigate]);


    //récupération des paramètres initiaux (import depuis un dossier existant)
    useEffect(() => {
        const { pet, petOwner } = location.state || {};

        const setInitialData = async () => {
            document.getElementById("loading").style.display = "flex";
            if (petOwner) {
                const petOwnerInitialData = PetOwner.fromJSON(petOwner);
                setData((prevData) => ({
                    ...prevData,
                    petOwner: petOwnerInitialData
                }))
            }
            if (pet) {
                const petInitialData = Pet.fromJSON(pet[0]);
                setData((prevData) => ({
                    ...prevData,
                    pet: petInitialData

                }))
            }
            document.getElementById("loading").style.display = "none";
        }
        if (pet || petOwner) setInitialData();
    }, [location.state])

    //Query import
    const queryImport = (queryParams) => {

        let birthDateQuery = "";
        if (queryParams.get('bd_year') && queryParams.get('bd_month') && queryParams.get('bd_day')) {
            birthDateQuery = new Date(queryParams.get('bd_year'), parseInt(queryParams.get('bd_month'), 10) - 1, queryParams.get('bd_day')) || "";
        }

        return {
            fromQuery: queryParams.get('from') || "",
            guidQuery: queryParams.get('reference') || "",
            firstnameQuery: queryParams.get('firstname') || "",
            nameQuery: queryParams.get('name') || "",
            emailQuery: queryParams.get('email') || "",
            countryQuery: queryParams.get('country') || "",
            phoneQuery: queryParams.get('phone')?.replace(/\D/g, '') || "",
            streetQuery: queryParams.get('street') || "",
            streetNumberQuery: queryParams.get('st_nb') || "",
            localityQuery: queryParams.get('locality') || "",
            boxQuery: queryParams.get('box') || "",
            postalCodeQuery: queryParams.get('postal_code') || "",
            animalNameQuery: queryParams.get('animal') || "",
            chipQuery: queryParams.get('chip') || "",
            breedQuery: queryParams.get('breed') || "",
            birthDateQuery: birthDateQuery,
            specieQuery: queryParams.get('species') || "",
            sexeQuery: queryParams.get('sex') || "",
            sterilisationQuery: queryParams.get('sterilisation') || "",
            firmQuery: queryParams.get('firm') || "",
            vatQuery: queryParams.get('vat') || "",
            languageQuery: queryParams.get('language') || "FR"
        }
    }

    const handleNextTab = () => {
        if (tab === 1) {
            handleGoToForm3();
        } else if (tab === 2) {
            if (atLeastOneAnalyse(analyses, bilans)) {
                if (!data.pet.chip && hasGeneticAnalyse(analyses)) {
                    alert("Dans le cas d'une analyse génétique, merci de mentionner l'ID chip de l'animal à la page précédente.");
                } else {
                    setTab(3);
                }
            } else {
                alert('Selectionnez au minimum une analyse pour continuer.');
            }
        } else if (tab === 3) {
            if (validateAllFieldForm4()) {
                pushData();
            }
        }
    }
    const handleGoToForm3 = async () => {
        const isValid = await validateAllFieldForm12()
        if (isValid) {
            setTab(2);
        } else {
            alert("Champ(s) invalide(s)");
        }
    }
    const validateAllFieldForm4 = () => {
        let validation = true;
        let validationLabelTmp = { ...validationLabel };

        //Champs requis
        if (!validEmpty(data.orderNb)) {
            validation = window.confirm("La demande de prescription ne comporte pas de numéro d'étiquette. Pour continuer appuyer sur OK. Pour remplir un numéro d'étiquette cliquez sur Annuler.")
        } else {
            if (!validOrderNr(data.orderNb)) {
                validationLabelTmp.orderNb = "Numéro invalide";
                validation = false;
            }
        }

        setValidationLabel(validationLabelTmp);
        return validation;
    }

    const validateAllFieldForm12 = async () => {

        let validation = true;
        let validationLabelTmp = { ...validationLabel };

        //Email
        if (!noMail) {
            if (!validEmpty(data.petOwner.email)) {
                validationLabelTmp.email = "Requis";
                validation = false;
            } else if (!validMail(data.petOwner.email)) {
                validationLabelTmp.email = "Email invalide";
                validation = false;
            }
        }
        //Phone
        if (!account.superuser) {
            if (!validEmpty(data.petOwner.phone)) {
                validationLabelTmp.phone = "Requis";
                validation = false;
            } else if (!validPhone(data.petOwner.phone)) {
                validationLabelTmp.phone = "Numéro invalide";
                validation = false;
            }
        }
        // TVA
        if (data?.petOwner?.vat?.length > 0){
            document.getElementById("loading").style.display = "flex"
            const isVatValid = await validVat(data.petOwner.vat)
            document.getElementById("loading").style.display = "none"
            if(!isVatValid){
                validationLabelTmp.vat = "Numéro de TVA non valide"
                validation = false
            }
        }
        //Email copie des  résultats
        if (data.result_copy_name || data.result_copy_mail) {
            if (!validEmpty(data.result_copy_mail)) {
                validationLabelTmp.result_copy_mail = "Email requis"
                validation = false
            }
            else if (!validMail(data.result_copy_mail)) {
                validationLabelTmp.result_copy_mail = "Email invalide";
                validation = false;
            }
            if (!validEmpty(data.result_copy_name)) {
                validationLabelTmp.result_copy_name = "Nom requis"
                validation = false
            }

        }
        //Champs requis
        if (!validEmpty(data.petOwner.name)) {
            validationLabelTmp.name = "Requis";
            validation = false;
        }
        if (!validEmpty(data.petOwner.firstname)) {
            validationLabelTmp.firstname = "Requis";
            validation = false;
        }
        if (!validEmpty(data.petOwner.name)) {
            validationLabelTmp.name = "Requis";
            validation = false;
        }
        if (!validEmpty(data.pet.specie_id)) {
            validationLabelTmp.specie = "Requis";
            validation = false;
        }
        if (!validEmpty(data.pet.name)) {
            validationLabelTmp.petName = "Requis";
            validation = false;
        }
        //Champs requis sauf si facturation vete
        if (!data.billingPrescriber) {
            if (!validEmpty(data.petOwner.address.street)) {
                validationLabelTmp.street = "Requis";
                validation = false;
            }
            if (!validEmpty(data.petOwner.address.getLocalityId())) {

                validationLabelTmp.locality = "Adresse incomplète";
                validationLabelTmp.postal_code = "Adresse incomplète";
                validationLabelTmp.country = "Adresse incomplète";
                validation = false;
            }
            if (!validEmpty(data.petOwner.address.street_nb)) {
                validationLabelTmp.street_nb = "Requis";
                validation = false;
            }
        }

        setValidationLabel(validationLabelTmp);
        return validation;
    }
    const pushData = () => {
        //Structuring data

        const json = {
            source: "web",
            prescriber: activePrescriber?.id || null,
            guid: data.guid || null,
            external_source: data.external_source || null,
            analyses: fillAnalyses(analyses),
            bilans: fillBilans(analyses, bilans),
            animal: {
                birth_date: data.pet.getBirthDateAsString() || null,
                breed: data.pet.getBreedNameSync() || null,
                chip: data.pet.chip || null,
                name: data.pet.name || null,
                sex: data.pet.sex_id || null,
                species: data.pet.specie_id || null,
                sterilisation_status: data.pet.sterilisation_id || null,
                anamnesis: data.anamnesis || null
            },
            infos: {
                billing_prescriber: data.billingPrescriber,
                order_id: data.orderNb || null,
                comments_analyses: fillCommentsAnalyses(analyses),
                comments_bilans: fillCommentsBilans(analyses,bilans),
                result_copy: {
                    mail: data.result_copy_mail || null,
                    name: data.result_copy_name || null
                }
            },
            owner: {
                box: data.billingPrescriber ? null : (data.petOwner.address.postal_box || null),
                email: data.petOwner.email || null,
                first_name: data.petOwner.firstname || null,
                language: data.petOwner.language || "FR",
                last_name: data.petOwner.name || null,
                number: data.billingPrescriber ? null : (data.petOwner.address.street_nb || null),
                phone: data.petOwner.phone || null,
                locality: data.billingPrescriber ? null : (data.petOwner.address.getLocalityId() || null),
                street: data.billingPrescriber ? null : (data.petOwner.address.street || null),
                vat: data.billingPrescriber ? null : (data.petOwner.vat || null),
                company_name: data.billingPrescriber ? null : (data.petOwner.company_name || null),
            }
        }
        const xhttp = new XMLHttpRequest();
        document.getElementById("loading").style.display = "flex";
        xhttp.onload = function () {
            if (xhttp.status >= 200 && xhttp.status < 300) {
                const response = JSON.parse(this.responseText);
                document.getElementById("loading").style.display = "none";
                setPurchaseOrderId(Number.parseInt(response.internal_id));
                let text = !data.orderNb ? "Prescription envoyée. Veuillez joindre la prescription (lien ci-dessous) avec les échantillons." : "Prescription envoyée.";
                if (response.driver_message) text = text.concat("\n", "\n", response.driver_message);
                setAlertWindowText(text);
                setDisplayAlertWindow(true);
            } else {
                document.getElementById("loading").style.display = "none";
                window.alert(this.responseText);
            }
        }
        xhttp.open("POST", process.env.REACT_APP_API_URL + "order/", process.env.REACT_APP_API_HTTPS);
        xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
        xhttp.send(JSON.stringify(json));
    }

    //Chargement des paramètres
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const queries = useMemo(() => queryImport(queryParams), [queryParams]);
    
    useEffect(()=>{
        logInfo()
    },[])

    const [matchingLocalities, setMatchingLocalities] = useState([])
    useEffect(() => {
        loadLocality(setMatchingLocalities, navigate, queries.localityQuery)
    }, [queries.localityQuery, navigate])

    const setImportValues = (queries) => {
        if (queries.fromQuery && queries.fromQuery.toLowerCase() === "fuga") {

            const address = parseAddress(queries.streetQuery);
            const country = countries.find((country) => country.code === queries.countryQuery?.toUpperCase()) || {
                label: "",
                id: "",
                code: ""
            }
            const specie = species.find((specie) => specie.fuga_code?.toLowerCase() === queries.specieQuery?.toLowerCase()) || {
                label: "",
                id: ""
            };
            const sex = animalSex.find((sexe) => sexe.fuga_code?.toLowerCase() === queries.sexeQuery?.toLowerCase()) || {
                label: "",
                id: ""
            };
            const sterilisation = sterilisationStatus.find((item) => item.fuga_code?.toLowerCase() === queries.sterilisationQuery?.toLowerCase()) || {
                label: "",
                id: ""
            };

            const ownerAddress = new Address(address.streetName, address.streetNumber, address.boxNumber, "");
            ownerAddress.setCountry(country);
            ownerAddress.setPostalCode(queries.postalCodeQuery);
            const petOwner = new PetOwner(queries.firstnameQuery, queries.nameQuery, queries.emailQuery, queries.phoneQuery, ownerAddress, "", "",queries.languageQuery);
            const pet = new Pet(queries.animalNameQuery, specie.id, "", queries.breedQuery, queries.birthDateQuery, queries.chipQuery, sex.id, sterilisation.id);

            setData((o) => ({
                ...o,
                external_source: "fuga",
                guid: queries.guidQuery,
                petOwner: petOwner,
                pet: pet
            }));
        }
        else if (queries.fromQuery) {

            const locality = matchingLocalities[0] || {
                country: "",
                id: "",
                label: "",
                postal_code: ""
            };

            const ownerAddress = new Address(queries.streetQuery, queries.streetNumberQuery, queries.boxQuery, locality.id);
            if (!locality.id) {
                const country = countries.find((country) => country.code === queries.countryQuery?.toUpperCase()) || {
                    label: "",
                    id: ""
                }
                ownerAddress.setCountry(country);
                ownerAddress.setPostalCode(queries.postalCodeQuery);
            } else {
                const country = countries.find((country) => country.id === parseInt(locality.country)) || {
                    label: "",
                    id: ""
                }
                ownerAddress.setCountry(country);
                ownerAddress.setLocality(locality);
            }
            const petOwner = new PetOwner(queries.firstnameQuery, queries.nameQuery, queries.emailQuery, queries.phoneQuery, ownerAddress, queries.firmQuery, queries.vatQuery,queries.languageQuery);
            const pet = new Pet(queries.animalNameQuery, queries.specieQuery, "", queries.breedQuery, queries.birthDateQuery, queries.chipQuery, queries.sexeQuery, queries.sterilisationQuery);

            setData((o) => ({
                ...o,
                petOwner: petOwner,
                pet: pet,
                external_source: queries.fromQuery,
                guid: queries.guidQuery
            }));
        }
    }
    useEffect(() => setImportValues(queries), [queries, countries, species, animalSex, sterilisationStatus, matchingLocalities]);

    const [importWindowVisible, setImportWindowVisible] = useState(queries.fromQuery);
    const ImportWindow = () => {
        if (importWindowVisible) {
            return (
                <div className="popup-bg">
                    <div className="popup-window bg-white p-5 flex flex-col items-center max-w-[1000px] gap-5">
                        <img className="h-20 object-contain" alt="logo" src="/iconslimsvet/logo.png">
                        </img>
                        <h1>Nouvelle demande d'analyse depuis "{queries.fromQuery}"</h1>
                        <p className="text-justify w-96 text-red">Veuillez controler les données ci-dessous. Si certaines ne sont pas correctes, il vous sera possible de les modifier après avoir fermé cette fenêtre.</p>
                        <div className="flex flex-wrap gap-10 items-start space-between">
                            <div className="flex flex-col items-center">
                                <h2>Propriétaire de l'animal</h2>
                                <div className="grid grid-cols-2 pl-3">
                                    <p className="text-dark-green text-right mr-2">Prénom:</p><p className="italic">{data.petOwner.firstname}</p>
                                    <p className="text-dark-green text-right mr-2">Nom:</p><p className="italic">{data.petOwner.name}</p>
                                    <p className="text-dark-green text-right mr-2">Email:</p><p className="italic">{data.petOwner.email}</p>
                                    <p className="text-dark-green text-right mr-2">Téléphone:</p><p className="italic">{data.petOwner.phone}</p>
                                    <p className="text-dark-green text-right mr-2">Langue:</p><p className="italic">{data.petOwner.language}</p>
                                    <p className={queries.fromQuery.toLowerCase()==="fuga"?"hidden":"text-dark-green text-right mr-2"}>Société:</p><p className="italic">{data.petOwner.company_name}</p>
                                    <p className={queries.fromQuery.toLowerCase()==="fuga"?"hidden":"text-dark-green text-right mr-2"}>TVA:</p><p className="italic">{data.petOwner.vat}</p>
                                    <p className="text-dark-green text-right mr-2">Rue:</p><p className="italic">{data.petOwner.address.street}</p>
                                    <p className="text-dark-green text-right mr-2">Numéro de rue:</p><p className="italic">{data.petOwner.address.street_nb}</p>
                                    <p className="text-dark-green text-right mr-2">Boîte:</p><p className="italic">{data.petOwner.address.postal_box}</p>
                                    <p className="text-dark-green text-right mr-2">Code Postal:</p><p className="italic">{data.petOwner.address.getPostalCodeSync()}</p>
                                    <p className="text-dark-green text-right mr-2">Localité:</p><p className="italic">{data.petOwner.address.getLocalitySync()?.label}</p>
                                    <p className="text-dark-green text-right mr-2">Pays:</p><p className="italic">{data.petOwner.address.getCountry(countries)?.label}</p>
                                </div>
                            </div>
                            <div className="flex flex-col items-center">
                                <h2>Animal</h2>
                                <div className="grid grid-cols-2 pl-3">
                                    <p className="text-dark-green text-right mr-2">Nom de l'animal:</p><p className="italic">{data.pet.name}</p>
                                    <p className="text-dark-green text-right mr-2">Chip:</p><p className="italic">{data.pet.chip}</p>
                                    <p className="text-dark-green text-right mr-2">Date de naissance:</p><p className="italic">{data.pet.getBirthDateAsString()}</p>
                                    <p className="text-dark-green text-right mr-2">Espèce:</p><p className="italic">{data.pet.getSpecie(species).label}</p>
                                    <p className="text-dark-green text-right mr-2">Race:</p><p className="italic">{data.pet.getBreedNameSync()}</p>
                                    <p className="text-dark-green text-right mr-2">Sexe:</p><p className="italic">{data.pet.getSex(animalSex).label}</p>
                                    <p className="text-dark-green text-right mr-2">Stérilisation:</p><p className="italic">{data.pet.getSterilisation(sterilisationStatus).label}</p>
                                </div>
                            </div>

                        </div>

                        <div className="flex flex-col gap-3">
                            <TextButton onClick={() => setImportWindowVisible(false)} text="Poursuivre" />
                            <TextButton onClick={() => window.history.back()} text="Annuler la demande" red={true} />
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (
        <div className="h-full w-full flex flex-col overflow-y-auto overflow-x-hidden pb-5">
            <ImportWindow />
            <AlertWindow msg={alertWindowText} links={[{ href: () => loadPurchaseOrder(purchaseOrderId, navigate), txt: "Télécharger la prescription" }, { href: () => navigate("/main"), txt: "Retourner à l'accueil" }]} display={displayAlertWindow} />
            <div className="flex flex-row flex-wrap justify-around items-center m-3 gap-3 w-full">
                <div>
                    <Link to="/main"><img src="/iconslimsvet/logo.png" alt="logo" className="h-20"></img></Link>
                    <h1 className="text-red text-2xl font-light">NOUVELLE PRESCRIPTION</h1>
                </div>
                <FormLine dataTab={dataTab} activeTab={tab} />
            </div>
            <div className="flex flex-row flex-wrap items-center justify-center gap-5 grow">
                <NextArrow direction="previous" display={tab === 1 ? "hide" : ""} handleClick={() => setTab(tab - 1)} />
                <Form12 hidden={tab === 1 ? false : true} activePrescriber={activePrescriber} setActivePrescriber={setActivePrescriber} prescribers={prescribers} isSuperuser={account.superuser} data={data} setData={setData} setNoMail={setNoMail} noMail={noMail} countries={countries} species={species} sterilisationStatus={sterilisationStatus} animalSex={animalSex} validationLabel={validationLabel} setValidationLabel={setValidationLabel} />
                <Form3 hidden={tab === 2 ? false : true} activePrescriber={activePrescriber} cost={cost} specieId={data.pet.specie_id} analyses={analyses} setAnalyses={setAnalyses} matrix={matrix} setMatrix={setMatrix} bilans={bilans} setBilans={setBilans} />
                <Form4 hidden={tab === 3 ? false : true} activePrescriber={activePrescriber} cost={cost} analyses={analyses} bilans={bilans} matrix={matrix} data={data} setData={setData} handleNext={handleNextTab} countries={countries} species={species} animalSex={animalSex} sterilisationStatus={sterilisationStatus} validationLabel={validationLabel} setValidationLabel={setValidationLabel} />
                <NextArrow display={tab === 3 ? "hide" : ""} handleClick={handleNextTab} />
            </div>
        </div>
    );

}









